import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_REGISTERED_USERS = restRequest("USER_MANAGER_V2.GET_REGISTERED_USERS");
export const SET_NEW_USERS = restRequest("USER_MANAGER_V2.SET_NEW_USERS");
export const REMOVE_USER = restRequest("USER_MANAGER_V2.REMOVE_USER");
export const GET_QUALIFICATIONS = restRequest("USER_MANAGER_V2.GET_QUALIFICATIONS");
